export const required = (value, name) => {
    if (!value.toString().trim().length) {
        // We can return string or jsx as the 'error' prop for the validated Component
        return `${name} is required`;
    }
    return false;
};

export const lt = (value, props) => {
    // get the maxLength from component's props
    if (value > props) {
        // Return jsx
        return true
    }
    return false;
};

export const isInt = (value) => {
    var n = Math.floor(Number(value));
    var check = String(n) === value && n >= 0;
    if (check) {
        return false;
    }
    return true;
};

export const isUrl = (value) => {
    let isurl = /^(?:(?:https?|ftp):\/\/)?(?:(?!(?:10|127)(?:\.\d{1,3}){3})(?!(?:169\.254|192\.168)(?:\.\d{1,3}){2})(?!172\.(?:1[6-9]|2\d|3[0-1])(?:\.\d{1,3}){2})(?:[1-9]\d?|1\d\d|2[01]\d|22[0-3])(?:\.(?:1?\d{1,2}|2[0-4]\d|25[0-5])){2}(?:\.(?:[1-9]\d?|1\d\d|2[0-4]\d|25[0-4]))|(?:(?:[a-z\u00a1-\uffff0-9]-*)*[a-z\u00a1-\uffff0-9]+)(?:\.(?:[a-z\u00a1-\uffff0-9]-*)*[a-z\u00a1-\uffff0-9]+)*(?:\.(?:[a-z\u00a1-\uffff]{2,})))(?::\d{2,5})?(?:\/\S*)?$/;
    if (isurl.test(value)) {
        return true;
    }
    return false;
}